
 $(function() {
   // Invoke the plugin
   $('input, textarea').placeholder();
   var html;
  });
  var x = $('.articles'); 
  var w = $(window).width();
  if(w >= 600 && w <= 797) {
      x.removeClass('span8').addClass('span12');
  }

  var x = $('.inner-right'); 
  var w = $(window).width();
  if(w >= 768 && w <= 1026) {
      x.removeClass('span9').addClass('span11');
  }

  var x = $('#blog-home'); 
  var w = $(window).width();
  if(w >= 768 && w <= 1026) {
      x.removeClass('span6').addClass('span12');
  }
  if(w >= 600 && w <= 797) {
      x.removeClass('span6').addClass('span12');
}

  var x = $('.con-frm'); 
  var w = $(window).width();
  if(w >= 510 && w <= 797) {
      x.removeClass('span4').addClass('span12');
  }             

  var x = $('.page-with-contact-form'); 
  var w = $(window).width();
  if(w >= 510 && w <= 797) {
      x.removeClass('span4').addClass('span12');
  }

  var x = $('#crt-nts'); 
  var w = $(window).width();
  if(w >= 600 && w <= 1026) {
      x.removeClass('span6').addClass('span11');
  }


  var x = $('#crt-btns'); 
  var w = $(window).width();
  if(w >= 600 && w <= 1026) {
      x.removeClass('span6').addClass('span11');
  }


  var x = $('.articles'); 
  var w = $(window).width();
  if(w >= 509 && w <= 768) {
      x.removeClass('span8').addClass('span12');
  }